import React, {
  useState,
  useEffect,
  useRef,
  useLayoutEffect,
  useMemo,
} from "react";
import {
  Box,
  Button,
  Typography,
  Grid,
  Collapse,
  Divider,
  CircularProgress,
  Card,
  CardContent,
} from "@mui/material";
import { useNavigate, Outlet, useParams, useLocation } from "react-router-dom";
import jsonData from "./mainpageconfig.json";
import SearchSharpIcon from "@mui/icons-material/SearchSharp";
import IconButton from "@mui/material/IconButton";
import InputBase from "@mui/material/InputBase";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import CircleProgressBar from "../progress/CircleProgressBar";
import { LinearProgress } from "@mui/material";
import ApiMap from "../../utils/ApiMap";
import AuthService from "../../utils/AuthService";
import axios from "axios";
import PlayCircleOutlineIcon from "@mui/icons-material/PlayCircleOutline";
import QuizIcon from "@mui/icons-material/Quiz";
import Tooltip from "@mui/material/Tooltip";
import { Avatar } from "@mui/material";
import AssignmentIcon from "@mui/icons-material/Assignment";
import AutoStoriesIcon from "@mui/icons-material/AutoStories";
import OpenInFullIcon from "@mui/icons-material/OpenInFull";
import CourseServices from "../../apis/CourseServices";

const MainPage = ({ setShowAppBar }) => {
  const [isShrunk, setIsShrunk] = useState(false);
  const [showMainContent, setShowMainContent] = useState(true);
  const [isRoutedPageVisible, setIsRoutedPageVisible] = useState(false);
  const [isFirstRender, setIsFirstRender] = useState(true);
  const [isSearchVisible, setIsSearchVisible] = useState(false);
  const [expandedLinkIndex, setExpandedLinkIndex] = useState([]);
  const detailsSectionRef = useRef(null);
  const navigate = useNavigate();
  const [isSidebarHidden, setIsSidebarHidden] = useState(false);
  const [shouldAutoHideSidebar, setShouldAutoHideSidebar] = useState(false);
  const [lessonProgress, setLessonProgress] = useState({});
  const [validLessonIds, setValidLessonIds] = useState([]);
  const [moduleList, setModuleList] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  let { courseId } = useParams();
  const [crsId] = useState(courseId);
  let moduleId = 2;
  const [modCid] = useState(moduleId);
  const [lessonList, setLessonList] = useState(null);
  const [moduleLessons, setModuleLessons] = useState({});
  const [loadingModules, setLoadingModules] = useState({});
  const location = useLocation();
  const [activeModuleId, setActiveModuleId] = useState(null);
  const [details, setDetails] = useState(null);
  const [expanded, setExpanded] = useState(false);
  const [userGrades, setUserGrades] = useState([]);
  const [courseName, setCourseName] = useState("");
  const sidebarWidth = useMemo(() => {
    if (isSidebarHidden) return "0px";

    if (shouldAutoHideSidebar && window.innerWidth <= 768) {
      return jsonData.columns[0]?.content.mobileWidth; // Use mobile width if auto-hide is enabled
    }

    return isShrunk
      ? jsonData.columns[0]?.content.shrinkWidth
      : jsonData.columns[0]?.content.unshrinkWidth;
  }, [isSidebarHidden, isShrunk, shouldAutoHideSidebar]);

  useLayoutEffect(() => {
    setShowAppBar(false);
    return () => {
      setShowAppBar(true);
    };
  }, [setShowAppBar]);
  useEffect(() => {
    if (location.state?.courseName) {
      setCourseName(location.state.courseName);
    }
  }, [location.state]);

  useEffect(() => {
    if (!isShrunk) return;
    const handleResize = () => {
      setIsSidebarHidden((prev) => {
        if (window.innerWidth <= 768) {
          return true;
        }
        return false;
      });
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [isShrunk]);

  useEffect(() => {
    if (!isFirstRender) {
      setShowMainContent(false);
      const timeout = setTimeout(() => {
        setShowMainContent(true);
      }, 700);
      return () => clearTimeout(timeout);
    }
  }, [isShrunk]);

  useEffect(() => {
    setIsFirstRender(false);
  }, []);

  useEffect(() => {
    if (location.pathname === `/Modules/Course/${courseId}`) {
      setIsShrunk(false); // Expands sidebar when back to course page
    } else {
      setIsShrunk(true); // Shrinks sidebar when moving forward to lesson
    }
  }, [location.pathname, courseId]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsLoading(true); // Set loading to true before fetching
        const resp = await axios(
          `${ApiMap.COURSE_MODULES}/course/${courseId}/modules`,
          AuthService.getAuthHeader()
        );
        let modList = resp.data;
        modList.sort((a, b) => a.id - b.id);
        setModuleList(modList);
      } catch (error) {
        console.error("Error fetching modules:", error);
      } finally {
        setIsLoading(false); // Ensure loading is false after fetch
      }
    };

    if (AuthService.isLoggedIn()) {
      fetchData();
    }
  }, [crsId]); // Depend on crsId

  // useEffect(() => {
  //   const fetchData = async () => {
  //     const resp = await axios(
  //       `${ApiMap.MODULES_LESSONS}/course/${courseId}/module/${moduleId}/lessons`,
  //       AuthService.getAuthHeader()
  //     );

  //     var lsnList = resp.data;
  //     lsnList.sort((a, b) => a.seq - b.seq);
  //     setLessonList(lsnList);
  //   };

  //   if (AuthService.isLoggedIn()) {
  //     fetchData();
  //   }
  // }, []);

  if (isLoading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", mt: 5 }}>
        <CircularProgress size={24} />
      </Box>
    );
  }

  const handleProgressClick = async (
    lessonId,
    moduleId,
    chapterId,
    dateCompleted
  ) => {
    if (!AuthService.isFaculty(courseId)) {
      return; // Students cannot toggle progress
    }
    console.log(lessonProgress);
    const progress = lessonProgress[moduleId]?.[lessonId];

    const isCompleted =
      progress !== undefined ? progress === 100 : !!dateCompleted;

    console.log(isCompleted);
    if (isCompleted) {
      const resp = await CourseServices.markLessonInComplete(
        courseId,
        moduleId,
        chapterId,
        lessonId
      );
      if (resp.status === 200) {
        setLessonProgress((prev) => ({
          ...prev,
          [moduleId]: {
            ...(prev[moduleId] || {}),
            [lessonId]: 0,
          },
        }));
      }
    } else {
      const resp = await CourseServices.markLessonComplete(
        courseId,
        moduleId,
        chapterId,
        lessonId
      );
      if (resp.status === 200) {
        setLessonProgress((prev) => ({
          ...prev,
          [moduleId]: {
            ...(prev[moduleId] || {}),
            [lessonId]: 100,
          },
        }));
      }
    }
  };

  const handleInActiveLessons = (inactiveIds) => {
    const inValidIdsAsIntegers = inactiveIds.map((id) => parseInt(id, 10));
    setValidLessonIds(inValidIdsAsIntegers); // Update state with valid lesson IDs
  };

  const handleStartCourse = () => {
    setShouldAutoHideSidebar(true);
    const lessonsData = lessonList; // Assuming lessons are stored here
    setIsShrunk(true);
    setTimeout(() => {
      setIsRoutedPageVisible(true);
      navigate(
        `/Modules/Course/${courseId}/Module/${1}/Lesson/${3}/Chapter/${1}/Content/${3}`,
        {
          state: {
            lessons: lessonsData,
          },
        }
      ); // Pass lessons as state
    }, 700);
  };

  // const handleStartCourseOnLink = (link) => {
  //   console.log(lessonList, link);
  //   const lessonsLinkData = lessonList.filter(
  //     (lesson) => lesson.courseId === link.courseId // Match the lesson based on courseId
  //   );
  //   setIsShrunk(true);
  //   setTimeout(() => {
  //     setIsRoutedPageVisible(true);
  //     navigate("coursepage", {
  //       state: {
  //         lessons: lessonsLinkData,
  //         moduleId: moduleId,
  //         courseId: link.courseId,
  //       },
  //     }); // Pass lessons as state
  //   }, 700);
  // };

  const handleViewDetails = () => {
    if (!moduleList) return; // Avoid errors if moduleList is null
    const overView =
      "This is the foundational level where you learn the crucial 20% of the language needed to comprehend 80% of the Quran and Arabic. You'll master 8 key sounds and basic sounds of Arabic, using a distinctive approach to language learning.";
    const totalModules = moduleList.length;
    const totalDuration = moduleList.reduce(
      (acc, module) => acc + (module.duration || 0),
      0
    );
    const hours = Math.floor(totalDuration / 60);
    const minutes = totalDuration % 60;
    const formattedDuration = `${hours} hr ${minutes} min`;
    setDetails({ totalModules, totalDuration, formattedDuration, overView }); // Store in state
    setExpanded(!expanded); // Toggle expand state
  };

  const handleExit = () => {
    setIsShrunk(false);
    setIsRoutedPageVisible(false);
    setIsSidebarHidden(false);
    navigate("/coursepage");
  };

  const handleSearchToggle = () => {
    setIsSearchVisible((prev) => !prev); // Toggle visibility of the search input
  };

  const handleToggleLessons = async (index, moduleId) => {
    setActiveModuleId(moduleId);
    setExpandedLinkIndex((prevIndices) =>
      prevIndices.includes(index)
        ? prevIndices.filter((i) => i !== index)
        : [...prevIndices, index]
    );

    if (!moduleLessons[moduleId]) {
      setLoadingModules((prev) => ({ ...prev, [moduleId]: true })); // Start loading

      try {
        const resp = await axios.get(
          `${ApiMap.MODULES_LESSONS}/course/${crsId}/module/${moduleId}/lessons`,
          AuthService.getAuthHeader()
        );

        let lsnList = resp.data.sort((a, b) => a.seq - b.seq);
        console.log(lsnList);
        setModuleLessons((prevLessons) => ({
          ...prevLessons,
          [moduleId]: lsnList,
        }));
        // 🔥 Fetch grades for each lesson
        const gradesData = await fetchGradesForLessons(
          lsnList,
          courseId,
          moduleId
        );
        setUserGrades((prevGrades) => [
          ...prevGrades,
          ...Object.entries(gradesData).map(([lessonId, gradeObj]) => ({
            lessonId,
            moduleId,
            gradeObtained: gradeObj?.gradeObtained ?? null, // extract gradeObtained
            gradedAllowed: gradeObj?.gradeAllowed ?? null,
          })),
        ]);
      } catch (error) {
        console.error("Error fetching lessons:", error);
      } finally {
        setLoadingModules((prev) => ({ ...prev, [moduleId]: false })); // Stop loading
      }
    }
  };

  const fetchGradesForLessons = async (lessons, courseId, moduleId) => {
    const authToken = AuthService.getAuthHeader();
    const token = authToken.headers?.Authorization;
    if (!token) {
      console.error("Authorization token is missing");
      return {};
    }
    const myHeaders = new Headers();
    myHeaders.append("Authorization", token);
    myHeaders.append("Content-Type", "application/json");
    if (lessons.length === 0) return {};
    const raw = JSON.stringify({
      Name: "MyAssignmentSubmissions",
      Key: `user#{{myid}}`,
      SKey: {
        value: `submission;crs#${courseId};mod#${moduleId};chp#${1};`,
        optype: "begins",
      },
    });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    try {
      const response = await fetch(
        `https://dev.marvelapi.com/app/v1/getitems`,
        requestOptions
      );
      const result = await response.json();
      const allSubmissions = result || []; // in case result.items is the array
      console.log(allSubmissions);
      const gradesData = {};
      lessons.forEach((lesson) => {
        const match = allSubmissions.find((item) =>
          item.SK.includes(`id#${lesson.id}`)
        );
        gradesData[lesson.id] = match || null; // If not found, store null
      });
      return gradesData;
    } catch (error) {
      console.error("Error fetching grades:", error);
      return {};
    }
  };
  const getFilteredLessons = (link) => {
    return moduleLessons[link.id] || [];
  };

  const handleStartCourseOnLesson = (lesson, moduleId) => {
    console.log("lesson");
    setActiveModuleId(moduleId); // Track active module
    setShouldAutoHideSidebar(true);
    if (window.innerWidth <= 768) {
      setIsSidebarHidden(true);
    }
    const allLessons = moduleLessons[moduleId] || [];
    const chapter = allLessons.find((item) => item.id === lesson.id);
    const chapterId = chapter ? chapter.chapterId : null;
    const contentId = chapter ? chapter.id : null;
    setIsShrunk(true);
    setTimeout(
      () => {
        setIsRoutedPageVisible(true);
        navigate(
          `/Modules/Course/${courseId}/Module/${moduleId}/Chapter/${chapterId}/Lesson/${lesson.id}`,
          {
            replace: false,
            state: {
              lessons: allLessons,
              lessonName: lesson.name,
              contentId: contentId,
            },
          }
        );
      },
      isShrunk ? 0 : 700
    );
  };

  const calculateModuleProgress = () => {
    if (!moduleLessons || !activeModuleId || !moduleLessons[activeModuleId]) {
      return 0;
    }
    const lessons = moduleLessons[activeModuleId];

    if (!lessons || lessons.length === 0) {
      return 0;
    }
    const totalLessons = lessons.length;
    const completedLessons = lessons.filter(
      (lesson) => lessonProgress?.[lesson.id] === 100
    );
    const progress = (completedLessons.length / totalLessons) * 100;

    return progress;
  };

  const getModuleProgress = (moduleLessons, linkId) => {
    const filteredLessons = moduleLessons[linkId];
    if (!filteredLessons || filteredLessons.length === 0) return null;

    const completedLessons = filteredLessons.filter(
      (l) => l.dateCompleted
    ).length;
    const totalLessons = filteredLessons.length || 1;
    return Math.round((completedLessons / totalLessons) * 100);
  };

  return (
    <Grid
      container
      direction="column"
      sx={{
        minHeight: "100vh",
      }}
    >
      {showMainContent && (
        <Box>
          <Button
            sx={{
              position: "fixed",
              top: 0,
              right: 0,
              zIndex: 1001,
              margin: "10px",
            }}
            onClick={handleExit}
          >
            Exit Course
          </Button>
        </Box>
      )}
      <Box
        sx={{
          display: "flex",
          minHeight: "100vh",
          width: "100%",
        }}
      >
        <Box
          sx={{
            width: sidebarWidth,
            transition: "width 0.5s ease, opacity 0.5s ease",
            overflowX: "auto",
            position: "fixed",
            left: 0,
            top: 0,
            zIndex: 1000,
            borderRight: "2px solid #e0e0e0",
            height: "100vh",
          }}
        >
          {/* Header Section */}
          <Grid
            item
            sx={{
              width: "100%",
              height: isShrunk ? "45vh" : "55vh",
              bgcolor: "primary.main",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              transition: "height 0.7s ease-out",
              paddingLeft: isShrunk ? "5px" : "none",
              padding: 2,
            }}
          >
            {isShrunk && showMainContent && (
              <Box sx={{ position: "absolute", top: 0, right: 0 }}>
                <IconButton
                  onClick={handleSearchToggle}
                  sx={{ color: "#ffffff" }}
                >
                  <SearchSharpIcon />
                </IconButton>
              </Box>
            )}

            {isSearchVisible && isShrunk && showMainContent && (
              <InputBase
                placeholder="Search..."
                sx={{
                  width: "90%", // Adjusted width to make it smaller
                  height: "30px", // Set a fixed height for compactness
                  borderRadius: "15px", // Reduced border radius for a cleaner appearance
                  padding: "4px 8px", // Reduced padding for a smaller design
                  boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)", // Lighter shadow for subtle styling
                  marginRight: "15px",
                  backgroundColor: "#ffffff",
                }}
              />
            )}

            {showMainContent && (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "flex-start",
                  alignItems: "flex-start",
                  flexDirection: "column",
                  width: "100%",
                  maxWidth: 500,
                }}
              >
                <Box>
                  <Typography
                    variant="h3"
                    sx={{
                      //fontSize: isShrunk ? "1.8rem" : "2rem",
                      fontFamily: "Lato, sans-serif",
                      transition: "font-size 0.7s ease-out",
                      marginBottom: "20px",
                      cursor: "pointer",
                      textAlign: isShrunk ? "center" : "left",
                      fontWeight: 900,
                      marginTop: "16px",
                      color: "#ffffff",
                    }}
                    onClick={handleExit}
                  >
                    {courseName || "Welcome to the Course"}
                  </Typography>
                </Box>
                {isShrunk && (
                  <Box
                    sx={{ width: "100%", marginTop: "16px", padding: "10px" }}
                  >
                    {/* Linear Progress Bar */}
                    <LinearProgress
                      variant="determinate"
                      value={calculateModuleProgress()}
                      sx={{
                        height: "2px",
                        borderRadius: "4px",
                        "& .MuiLinearProgress-bar": {
                          backgroundColor: "#ffffff", // Custom color for the progress bar
                        },
                      }}
                    />

                    {/* Percentage and Completed Message */}
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "flex-start", // Align to the left
                        margin: "4px", // Add some space below the progress bar
                      }}
                    >
                      <Typography variant="body2">
                        {`${Math.round(calculateModuleProgress())}% Completed`}
                      </Typography>
                    </Box>
                  </Box>
                )}

                {!isShrunk && showMainContent && (
                  <Box sx={{ display: "flex", gap: "16px" }}>
                    {jsonData.columns[0]?.content.buttons?.map(
                      (button, index) => (
                        <Button
                          key={index}
                          variant="contained"
                          color="white"
                          sx={{
                            borderRadius: "15px",
                            transition: "all 0.7s ease-out",
                          }}
                          onClick={() => {
                            if (button.action === "handleStartCourse") {
                              handleStartCourse(); // Pass lessonsData to the handler
                            } else {
                              handleViewDetails();
                            }
                          }}
                        >
                          {button.label}
                          {button.label === "View Course Details" ? (
                            expanded ? (
                              <ExpandLessIcon />
                            ) : (
                              <ExpandMoreIcon />
                            )
                          ) : null}
                        </Button>
                      )
                    )}
                  </Box>
                )}
                <Collapse in={expanded} sx={{ marginTop: "10px" }}>
                  {details && !isShrunk && (
                    <Card
                      sx={{
                        borderRadius: "10px",
                        boxShadow: 2,
                        padding: "8px",
                        marginRight: 3,
                      }}
                    >
                      <CardContent
                        sx={{
                          display: "flex",
                          flexDirection: "column", // Ensures content stacks vertically
                          alignItems: "flex-start", // Align content to the left
                          gap: 1, // Adds spacing between sections
                          padding: "2px 8px",
                        }}
                      >
                        {/* First row: Video Count, Total Modules, and Duration */}
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            width: "100%", // Ensures it takes full width
                          }}
                        >
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              gap: 1,
                            }}
                          >
                            <IconButton>
                              <PlayCircleOutlineIcon />
                            </IconButton>
                            <Typography

                            //sx={{ color: "#455a64", fontSize: "0.75rem" }}
                            >
                              {details.videoCount} Videos
                            </Typography>
                          </Box>

                          <Typography
                            variant="body2"
                            sx={{
                              marginRight: 2,
                            }}
                          >
                            <strong>Total Modules:</strong>{" "}
                            {details.totalModules}
                          </Typography>

                          <Typography
                            variant="body2"
                            //sx={{ color: "#455a64", fontSize: "0.75rem" }}
                          >
                            <strong>Total Dur:</strong>{" "}
                            {details.formattedDuration}
                          </Typography>
                        </Box>

                        {/* Second row: Overview - This will appear below the first row */}
                        <Typography
                          variant="body2"
                          sx={{
                            marginTop: "8px", // Space between first row and overview
                            width: "100%", // Ensures it spans full width
                          }}
                        >
                          <strong>Overview:</strong> {details.overView}
                        </Typography>
                      </CardContent>
                    </Card>
                  )}
                </Collapse>
              </Box>
            )}
          </Grid>

          {/* Content Section */}
          {showMainContent && (
            <Grid
              item
              ref={detailsSectionRef}
              sx={{
                width: "100%",
                flex: 1,
                display: "flex",
                flexDirection: "column",
                justifyContent: isShrunk ? "flex-start" : "center",
                alignItems: isShrunk ? "flex-start" : "center",
                maxHeight: isShrunk ? "65vh" : "auto",
                padding: "8px",
                transition: "all 0.7s ease-out",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "flex-start",
                  alignItems: "flex-start",
                  flexDirection: "column",
                  width: "100%",
                  maxWidth: 500,
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    width: "100%",
                  }}
                >
                  {moduleList?.map((link, index) => (
                    <Box key={index} sx={{ width: "100%" }}>
                      <Box
                        sx={{
                          borderRadius: "4px",
                          display: "flex",
                          justifyContent: "space-between",
                          padding: "6px",
                          alignItems: "center",
                          position: "relative",
                          height: "60px",
                          cursor: "pointer",
                        }}
                        onClick={(event) => {
                          event.stopPropagation();
                          handleToggleLessons(index, link.id);
                        }}
                      >
                        {/* Left Section */}
                        <Box
                          sx={{
                            flex: 1,
                            display: "flex",
                            flexDirection: isShrunk ? "column" : "row",
                            alignItems: isShrunk ? "flex-start" : "center",
                            gap: "6px",
                            minWidth: "0",
                            overflow: "hidden",
                          }}
                        >
                          {/* Avatar */}
                          {!isShrunk && (
                            <Avatar
                              sx={{
                                fontWeight: "bold",
                                width: 36,
                                height: 36,
                                flexShrink: 0,
                                bgcolor: "primary.main",
                                color: "white",
                              }}
                            >
                              M
                            </Avatar>
                          )}

                          {/* Module Name */}
                          <Typography
                            variant="h5"
                            sx={{
                              fontWeight: 400,
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              flexGrow: 1,
                            }}
                          >
                            {link.name}
                          </Typography>

                          {/* Duration & Progress */}
                          <Box
                            sx={{
                              display: "flex",
                              flexDirection: "row",
                              alignItems: "center",
                              gap: "8px",
                              flexWrap: "nowrap",
                              whiteSpace: "nowrap",
                              flexShrink: 0,
                            }}
                          >
                            {expandedLinkIndex.includes(index) &&
                              getModuleProgress(moduleLessons, link.id) !==
                                null && (
                                <Box
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 1,
                                    flexGrow: 1,
                                    ml: 1,
                                  }}
                                >
                                  <Box
                                    sx={{
                                      flexGrow: 1,
                                      minWidth: 80,
                                      display: !isShrunk
                                        ? { xs: "none", sm: "block" }
                                        : "none",
                                    }}
                                  >
                                    <LinearProgress
                                      variant="determinate"
                                      value={getModuleProgress(
                                        moduleLessons,
                                        link.id
                                      )}
                                      sx={{
                                        height: 6,
                                        borderRadius: 3,
                                      }}
                                    />
                                  </Box>

                                  <Typography
                                    variant="caption"
                                    sx={{
                                      fontWeight: 400,
                                      minWidth: 30,
                                    }}
                                  >
                                    {getModuleProgress(moduleLessons, link.id)}%
                                  </Typography>
                                </Box>
                              )}

                            {/* Duration */}
                            <Typography
                              variant="caption"
                              sx={{
                                fontWeight: 500,
                                padding: "0px 4px",
                              }}
                            >
                              {Math.floor(link.duration / 60) > 0
                                ? `${Math.floor(link.duration / 60)} hr${
                                    Math.floor(link.duration / 60) > 1
                                      ? "s"
                                      : ""
                                  } `
                                : ""}
                              {link.duration % 60 > 0
                                ? `${link.duration % 60} min${
                                    link.duration % 60 > 1 ? "s" : ""
                                  }`
                                : ""}
                            </Typography>
                          </Box>
                        </Box>

                        {/* Expand/Collapse IconButton (always visible and aligned) */}
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            paddingLeft: "8px",
                          }}
                        >
                          <IconButton
                            sx={{
                              padding: "4px",
                              alignSelf: "center",
                            }}
                          >
                            {expandedLinkIndex.includes(index) ? (
                              <ExpandLessIcon />
                            ) : (
                              <ExpandMoreIcon />
                            )}
                          </IconButton>
                        </Box>
                      </Box>

                      <Divider />
                      <Collapse
                        in={expandedLinkIndex.includes(index)}
                        timeout="auto"
                        unmountOnExit
                        sx={{
                          padding: "0 16px",
                          marginTop: "8px",
                          borderLeft: "4px solid",
                          borderLeftColor: "primary.main",
                        }}
                      >
                        {loadingModules[link.id] ? (
                          <LinearProgress
                            sx={{
                              width: "60%", // Set width to 60%
                              margin: "10px auto", // Center horizontally
                              display: "block", // Ensures it behaves like a block element
                            }}
                          />
                        ) : getFilteredLessons(link).length > 0 ? (
                          getFilteredLessons(link).map(
                            (lesson, lessonIndex) => (
                              <React.Fragment key={lessonIndex}>
                                {/* Main Container - Align lesson details & progress bar */}
                                <Box
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                    padding: "8px 0",
                                    position: "relative",
                                  }}
                                >
                                  {/* Left Side - Lesson Details */}
                                  <Box sx={{ flex: 1 }}>
                                    {/* Lesson Name */}
                                    <Typography
                                      variant="h6"
                                      sx={{
                                        fontWeight: 650,
                                        wordWrap: "break-word",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        width: "100%",
                                        display: "flex", // Align items in a row
                                        alignItems: "center", // Vertically center icon & text
                                        gap: "4px", // Adds space between icon & text
                                        ...(isShrunk && {
                                          cursor: "pointer",
                                          "&:hover": {
                                            backgroundColor: "#f0f0f0",
                                          },
                                        }),
                                      }}
                                      onClick={() => {
                                        if (isShrunk) {
                                          handleStartCourseOnLesson(
                                            lesson,
                                            link.id
                                          );
                                        }
                                      }}
                                    >
                                      {lesson.contentType ===
                                      "formative_assessment" ? (
                                        <Tooltip title="Quiz" arrow>
                                          <QuizIcon
                                            sx={{
                                              cursor: "pointer",
                                            }}
                                          />
                                        </Tooltip>
                                      ) : lesson.contentType === "writing" ? (
                                        <Tooltip title="Assignment" arrow>
                                          <AssignmentIcon
                                            sx={{
                                              cursor: "pointer",
                                            }}
                                          />
                                        </Tooltip>
                                      ) : (
                                        <Tooltip title="Read" arrow>
                                          <AutoStoriesIcon
                                            sx={{
                                              cursor: "pointer",
                                            }}
                                          />
                                        </Tooltip>
                                      )}
                                      {lesson.name}
                                    </Typography>
                                    {lesson.openForStudent === true ||
                                    AuthService.isFaculty(courseId) ? (
                                      <Box
                                        sx={{
                                          display: "flex",
                                          flexDirection: "row",
                                          flexWrap: "wrap",
                                          alignItems: "center",
                                          gap: 1,
                                          marginTop: "4px",
                                        }}
                                      >
                                        {!isShrunk ? (
                                          <Button
                                            size="small"
                                            variant="contained"
                                            sx={{
                                              padding: "4px 10px",
                                              lineHeight: 1,
                                              whiteSpace: "nowrap",
                                              minWidth: "auto", // ✅ prevent wide button
                                              maxWidth: "100px",
                                              flexShrink: 0,
                                              flexGrow: 0,
                                            }}
                                            onClick={() =>
                                              handleStartCourseOnLesson(
                                                lesson,
                                                link.id
                                              )
                                            }
                                          >
                                            Open
                                          </Button>
                                        ) : null}

                                        {/* 🔥 Display Grades Here (Only if Available) */}

                                        {/* Duration */}
                                        <Typography
                                          variant="body2"
                                          sx={{
                                            fontWeight: 400,
                                            padding: "2px 6px",
                                            borderRadius: "4px",
                                            textAlign: "center",
                                            minWidth: "50px",
                                            flexWrap: "wrap",
                                            whiteSpace: "nowrap",
                                          }}
                                        >
                                          {lesson.duration} mins
                                        </Typography>
                                        {(() => {
                                          const gradeInfo = userGrades.find(
                                            (grade) =>
                                              grade.lessonId ===
                                                String(lesson.id) &&
                                              String(grade.moduleId) ===
                                                String(lesson.moduleId)
                                          );

                                          return gradeInfo &&
                                            gradeInfo.gradeObtained !== null ? (
                                            <Typography
                                              variant="body2"
                                              sx={{
                                                fontWeight: 400,
                                                padding: "2px 6px",
                                                borderRadius: "4px",
                                                textAlign: "center",
                                                minWidth: "50px",
                                                display: "inline-block",
                                                whiteSpace: "nowrap",
                                              }}
                                            >
                                              Grade: {gradeInfo.gradeObtained}
                                            </Typography>
                                          ) : null;
                                        })()}

                                        {!isShrunk && lesson.dateCompleted ? (
                                          <Typography
                                            variant="body2"
                                            sx={{
                                              fontWeight: 400,
                                              padding: "2px 6px",
                                            }}
                                          >
                                            {new Date(
                                              lesson.dateCompleted
                                            ).toLocaleDateString("en-US", {
                                              month: "short",
                                              day: "numeric",
                                              year: "numeric",
                                            })}
                                          </Typography>
                                        ) : null}
                                      </Box>
                                    ) : (
                                      <Typography
                                        variant="body2"
                                        sx={{
                                          fontWeight: 500,
                                          marginTop: "4px",
                                        }}
                                      >
                                        Not Open
                                      </Typography>
                                    )}
                                  </Box>

                                  {/* Right Side - Progress Bar (Now outside and at center-right) */}
                                  <Box
                                    sx={{
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "flex-end",
                                      minWidth: "30px", // Ensures it doesn't collapse
                                      flexShrink: 0, // Prevents shrinking in smaller screens
                                      alignSelf: "center", // Aligns it properly even when shrunk
                                      marginLeft: "8px", // Adds some spacing from the content
                                    }}
                                  >
                                    <CircleProgressBar
                                      progress={
                                        typeof lessonProgress[link.id]?.[
                                          lesson.id
                                        ] === "number"
                                          ? lessonProgress[link.id][lesson.id]
                                          : lesson.dateCompleted
                                          ? 100
                                          : 0
                                      }
                                      size={15}
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        handleProgressClick(
                                          lesson.id,
                                          link.id,
                                          lesson.chapterId,
                                          lesson.dateCompleted
                                        );
                                      }}
                                      disabled={AuthService.isStudent(courseId)}
                                    />
                                  </Box>
                                </Box>

                                {/* Light Divider Between Each Lesson */}
                                <Divider
                                  sx={{
                                    borderStyle: "dashed",
                                    borderWidth: "1px",

                                    marginY: "4px",
                                  }}
                                />
                              </React.Fragment>
                            )
                          )
                        ) : (
                          <Typography
                            sx={{
                              margin: "8px 0",
                            }}
                          >
                            No lessons available.
                          </Typography>
                        )}
                      </Collapse>
                    </Box>
                  ))}
                </Box>
              </Box>
            </Grid>
          )}
        </Box>
        {isRoutedPageVisible && (
          <Box
            sx={{
              flexGrow: 1, // ✅ Takes remaining space
              ml: sidebarWidth, // ✅ Prevents overlap
              overflow: "auto",
            }}
          >
            <Outlet
              context={{
                isShrunk,
                setIsShrunk,
                isSidebarHidden,
                setIsSidebarHidden,
                lessonProgress, // Pass the progress state
                setLessonProgress, // Pass the setter for updates
                handleProgressClick,
                handleInActiveLessons,
                sidebarWidth,
              }}
            />
          </Box>
        )}
      </Box>
    </Grid>
  );
};

export default MainPage;
